import React from 'react';

// Riga di proprietà stile Notion (mockup: classi .prop/.p-label/.p-value)
export interface PropRowProps {
  icon: React.ReactNode;            // icona lucide 12px (il chiamante passa strokeWidth 1.5)
  label: string;
  required?: boolean;               // asterisco rosso dopo la label
  danger?: boolean;                 // label rossa (Motivo della perdita)
  onClick?: () => void;
  trailing?: React.ReactNode;       // azione ghost: hover-only su desktop, SEMPRE visibile su touch
  trailingAlwaysVisible?: boolean;  // true = l'azione resta visibile anche senza passare col mouse
  wrap?: boolean;                   // true = il valore va a capo (chip invitati); default nowrap+ellipsis
  dataTour?: string;
  children: React.ReactNode;        // valore
}

export function PropRow({
  icon,
  label,
  required,
  danger,
  onClick,
  trailing,
  trailingAlwaysVisible,
  wrap,
  dataTour,
  children,
}: PropRowProps): JSX.Element {
  const labelColorClasses = danger
    ? 'text-red-500 dark:text-red-400'
    : 'text-[#787774] dark:text-gray-400';

  const valueClasses = wrap
    ? 'flex-1 min-w-0 flex items-center gap-1.5 text-[13px] text-[#37352F] dark:text-white flex-wrap gap-y-1'
    : 'flex-1 min-w-0 flex items-center gap-1.5 text-[13px] text-[#37352F] dark:text-white whitespace-nowrap overflow-hidden text-ellipsis';

  return (
    <div
      className="group flex items-center min-h-[30px] rounded px-1.5 py-0.5 cursor-pointer hover:bg-[rgba(55,53,47,0.08)] dark:hover:bg-white/[0.06]"
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); } } : undefined}
      data-tour={dataTour}
    >
      <div className={`flex items-center gap-1.5 w-32 shrink-0 text-xs font-medium ${labelColorClasses}`}>
        {icon}
        <span>{label}</span>
        {required && <span className="text-red-500 ml-0.5">*</span>}
      </div>
      <div className={valueClasses}>{children}</div>
      {trailing && (
        <div className={`ml-auto shrink-0 inline-flex items-center gap-1 text-[11px] text-[#787774] dark:text-gray-400 ${trailingAlwaysVisible ? '' : 'opacity-0 group-hover:opacity-100 [@media(hover:none)]:opacity-100'}`}>
          {trailing}
        </div>
      )}
    </div>
  );
}
